import React, { useEffect, useState, createContext, useContext } from 'react';
import { Language, translations } from '../translations/content';
type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: typeof translations.es;
  hasSelectedLanguage: boolean;
  setHasSelectedLanguage: (value: boolean) => void;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
const LANGUAGE_STORAGE_KEY = 'matrix-369-language';
const LANGUAGE_SELECTED_KEY = 'matrix-369-language-selected';
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>('es');
  const [hasSelectedLanguage, setHasSelectedLanguageState] = useState(false);
  useEffect(() => {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language | null;
    const hasSelected = localStorage.getItem(LANGUAGE_SELECTED_KEY) === 'true';
    if (storedLanguage && (storedLanguage === 'es' || storedLanguage === 'en')) {
      setLanguageState(storedLanguage);
    }
    setHasSelectedLanguageState(hasSelected);
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  };
  const setHasSelectedLanguage = (value: boolean) => {
    setHasSelectedLanguageState(value);
    localStorage.setItem(LANGUAGE_SELECTED_KEY, value.toString());
  };
  const t = translations[language];
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    hasSelectedLanguage,
    setHasSelectedLanguage
  }} data-id="element-235">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}